<template>
  <section class="sidebar">
    <div class="sidebar-box">
      <ul class="sidebar-list">
          <li
            class="sidebar-item"
            @mouseenter="handleMouseEnter('back-to-top')"
            @mouseleave="handleMouseLeave('back-to-top')"
            @click="backTop"
            v-show="isShowBackToTop"
          >
            <icon
              type="back_to_top"
              class="sidebar-item-icon"
            />
            <transition name="fade">
              <div class="sidebar-item-tips" v-show="isShowTips['back-to-top']">
                返回顶部
              </div>
            </transition>
          </li>
          <li class="sidebar-item" @mouseenter="handleShowQrcode" @mouseleave="handleCloseQrcode" >
              <icon
                type="wechat"
                class="sidebar-item-icon"
              />
              <transition name="fade">
                <div class="sidebar-qrcode" v-show="isShowQrcode">
                  <div class="sidebar-qrcode-box">
                    <img
                      class="sidebar-qrcode-pic"
                      :src="siteInfo.qrcode_url || qrcode_wechat"
                      alt="微信扫码"
                    />
                    <p class="sidebar-qrcode-tips" v-html="siteInfo.qrcode_label || qrcode_label"></p>
                  </div>
                </div>
            </transition>
          </li>
          <lr-link
            :to="feedBackLink"
            target="_blank"
            @click="handleFeedbackClick"
            @mouseenter="handleMouseEnter('comment-feedback')"
            @mouseleave="handleMouseLeave('comment-feedback')"
          >
            <li class="sidebar-item">
              <icon
                type="feedback"
                class="sidebar-item-icon"
              />
              <transition name="fade">
                <div class="sidebar-item-tips" v-show="isShowTips['comment-feedback']" @click.stop>
                  内容反馈
                </div>
              </transition>
            </li>
          </lr-link>
      </ul>
    </div>
  </section>
</template>

<script>
import FeedBackLink from '@/common/utils/feedback-link'

export default {
  name: 'PageSidebar',

  data() {
    return {
      isShowQrcode: false,
      feedBackLink:'',
      isShowBackToTop: false,
      isShowTips: { // 展示图标的hover提示
        'back-to-top': false,
        'comment-feedback': false
      },
      qrcode_wechat: require('~/assets/image/icon/wechat.png'),
      qrcode_label: '微信扫码'
    };
  },

  computed: {
    siteInfo() {
      return this.$store.state.common.siteInfo;
    }
  },

  methods: {
    handleShowQrcode() {
      this.$collect.sideedgeButtonShow('wechat');
      this.isShowQrcode = true;
    },

    handleCloseQrcode() {
      this.isShowQrcode = false;
    },

    handleFeedbackClick() {
      this.$collect.sideedgeFeedbackClick('feedback');
    },

    backTop() {
      this.$collect.sideedgeReturnClick('top');

      const timer = setInterval(function () {
        //获取滚动条距离顶部的高度
        const osTop =
          document.documentElement.scrollTop || document.body.scrollTop; //同时兼容了ie和Chrome浏览器

        //减小的速度
        const isSpeed = Math.floor(-osTop / 3);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + isSpeed;

        //判断，然后清除定时器
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 40);
    },

    handleMouseEnter(tip) {
      this.isShowTips[tip] = true;
    },

    handleMouseLeave(tip) {
      this.isShowTips[tip] = false;
    },

    handleShowBackToTop() {
      this.$eventBus.$on('@change_scroll', val => {
        if (val > (window.innerHeight || document.body.clientHeight)) {
          this.isShowBackToTop = true
        } else {
          this.isShowBackToTop = false
        }
      })
    }
  },

  async mounted() {
    this.feedBackLink = await FeedBackLink.getUrl();
    this.$collect.sideedgeButtonShow('all');
    this.handleShowBackToTop()
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  bottom: 20%;
  right: 8px;
  z-index: 7;
  text-align: center;
  font-size: 12px;

  &-box {
    // background: #ffffff;
    box-sizing: border-box;

    hr {
      width: 21px;
      margin: 15px 0 5px 0;
      padding: 0;
      display: inline-block;
      border: 0;
      border-top: 1px solid #e6e6e6;
    }
  }
  &-item,
  &-back-top {
    position: relative;
    @include flex-center();
    flex-direction: column;
    cursor: pointer;
    color: #222226;
    margin-bottom: 4px;
    .icon {
      font-size: 40px;
    }

    &:hover {
      background: rgba(8, 48, 93, 0.04);
      border-radius: 4px;
    }

    &:active {
      background: rgba(8, 48, 93, 0.08);
    }

    &-tips {
      width: 60px;
      padding: 2px 6px;
      background: rgba(17, 19, 23, 0.6);
      border-radius: 4px;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 44px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      cursor: none;
    }

    &-icon {
      width: 40px;
      height: 40px;
      color: #B9BDC6;

      svg {
        width: 40px;
        height: 40px;
      }

      &:hover {
        color: #6D7582;
      }

      &:active {
        color: #333840;
      }
    }
  }

  &-qrcode {
    padding: 22px 24px 18px 24px;
    position: absolute;
    top: -91px;
    right: 56px;
    z-index: 7;
    box-shadow: 0px 2px 12px 0px rgba(98, 107, 132, 0.4);
    border-radius: 8px;
    background-color: #ffffff;

    &-box {
      @include flex-center();
      flex-direction: column;
      border-radius: 8px;
      top: 30%;
      background-color: #ffffff;
      box-sizing: border-box;
    }

    &-close {
      font-size: 14px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;

      opacity: 0.2;

      &:hover {
        opacity: 0.5;
      }
    }

    &-pic {
      width: 140px;
      height: 140px;
    }
    &-tips {
      margin-top: 10px;
      text-align: center;
      font-size: 12px;
      color: #6D7582;
    }
  }
}

@media screen and (max-width: 986px) {
  .sidebar {
    display: none;
  }
}

.fade-enter{
  opacity: 0;
}
.fade-enter-active{
  transition: opacity .2s linear;
}
.fade-leave-to{
  opacity: 0;
}
.fade-leave-active{
  transition: opacity .2s linear;
}
</style>
